export default function ChatgptGetStarted() {
  return <h2>Chatgpt Get Started</h2>;
}
